import { DashboardComponent } from './dashboard.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BarLinesChartModule } from '../bar-lines-chart/bar-lines-chart.module';
import { ReportTableModule } from '../report-table/report-table.module';
import { MaterialModule } from '@sdbn/appclient';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonTranslationModule } from '@sdbn/common';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    SharedModule,
    BarLinesChartModule,
    ReportTableModule,
    CommonTranslationModule
  ],
  declarations: [DashboardComponent]
})
export class DashboardModule { }
